// Placeholders for the Customers tab, shown until the live source answers.

export type ModuleState = 'ok' | 'degraded' | 'down';

export interface ModuleStatus {
    module: string;
    state: ModuleState;
    summary: string;
    /** Ready-to-send sentence for customers; only set when something is wrong. */
    customerMessage?: string;
}

const minutesAgo = (m: number) => new Date(Date.now() - m * 60_000).toISOString();
const hoursAgo = (h: number) => minutesAgo(h * 60);

/** Shaped like a prod environment's stats from api/communicore/summary. */
export const deliveryStats = {
    outgoingEmails: {
        sent: 4812,
        failed: 63,
        pending: 4,
        stuck: 0,
        topErrors: [
            { error: 'Bounced: mailbox does not exist', count: 31, lastAt: minutesAgo(12) },
            { error: 'Rejected as spam by recipient server', count: 17, lastAt: hoursAgo(1) },
            { error: 'Bounced: mailbox full', count: 9, lastAt: hoursAgo(4) },
        ],
    },
    outgoingSms: {
        sent: 1290,
        failed: 18,
        pending: 0,
        stuck: 0,
        topErrors: [
            { error: 'Invalid phone number', count: 11, lastAt: hoursAgo(3) },
            { error: 'Carrier rejected message', count: 7, lastAt: hoursAgo(6) },
        ],
    },
    receivedEmails: 0,
};
